import {ScoringSystem} from '@legit.health/ui';
import * as Yup from 'yup';

function createValidatorForScoringSystem(scoringSystem: ScoringSystem) {
  return Yup.object().shape(
    scoringSystem.scoringSystemFacets
      .filter((ssf) => ssf.isAskedInQuestionnaire)
      .reduce(
        (acc2, scoringSystemFacet) => ({
          ...acc2,
          [scoringSystemFacet.id]: Yup.string().required('ui:form.errors.required')
        }),
        {}
      )
  );
}

export default function createSchema({questionnaires}: {questionnaires: ScoringSystem[]}) {
  return Yup.object({
    scoringSystems: questionnaires
      ? Yup.object().shape(
          questionnaires.reduce(
            (acc, scoringSystem) => ({
              ...acc,
              [scoringSystem.id]: createValidatorForScoringSystem(scoringSystem)
            }),
            {}
          )
        )
      : Yup.object()
  });
}
